import styled from 'styled-components'

export const Label = styled.div`
  display: block;
  font-size: 14px;
  font-weight: 400;
`

export const TextInput = styled.input`
  border: 1px solid #434958;
  border-radius: 8px;
  height: 36px;
  margin-top: 12px;
  outline: none;
  width: 100%;
  padding-left: 8px;
  background: transparent;
  border: 1px solid #fff;
  color: #fff;
`

export const TextArea = styled.textarea`
  border: 1px solid #434958;
  border-radius: 8px;
  margin-top: 12px;
  outline: none;
  width: 100%;
  padding-top: 8px;
  padding-left: 8px;
  background: transparent;
  border: 1px solid #fff;
  color: #fff;
`

export const SendButton = styled.button`
  background-color: #522ba4;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  outline: none;
  padding: 10px;
  text-align: center;
  width: 100%;
  color: #fff;
`

export const Wrapper = styled.div`
  background-color: #222429;
  padding: 24px;
  width: 100%;
`

export const ModalTitle = styled.div`
  font-size: 24px;
  font-weight: 500;
`

export const Form = styled.form`
  padding: 24px 0;
`
